<template>
  <div class="inquiry section-wrapper contents__area contents__area--terms">
    <div class="title">
      <h2 class="titleHead titleHead--terms">
        お問い合わせ
      </h2>
    </div>

    <div class="formFrame formFrame--result">
      <div class="message-area">
        <div class="resultHead">
          <i class="far fa-check-circle"></i>
          <p class="resultTitle">送信完了しました</p>
        </div>
        <div class="inquiryForm--result" inquiry="[object Object]">
          <p class="resultMessage">
            ご質問やお問い合わせを頂きました場合、内容次第で回答までにお時間を頂くことがございます。
            <br />弊社の担当者より順次返信させていただきますので、少々お待ちください。
          </p>
        </div>
      </div>
    </div>

    <div class="goToTopButton arrowIconBtn">
      <a
        type="button"
        class="buttonItem buttonItem--back"
        href="https://linku-s.com/"
      >
        <p class="buttonItem__text">Home</p>
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
});
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

.contents__area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
}

/* title */
.contents__area--terms .title {
  padding: 48px 0px 36px 0px;
}

.contents__area--terms .title h2 {
  text-align: center;
  color: #47536e;
  font-family: "Open Sans";
  white-space: break-spaces;
  word-break: keep-all;
  line-height: 1.4;

  @media screen and (max-width: 800px) {
    font-size: 22px;
  }
}

/* result */

.formFrame {
  margin: 0 auto;

  .resultHead {
    display: flex;
    justify-content: center;
    margin-bottom: 28px;

    .resultTitle {
      font-size: 20px;
      margin: 15px 0px 15px 0px;
      font-weight: bold;
      font-family: "Open Sans";
      color: #47536e;
    }

    i {
      font-size: 50px;
      color: #f299b1;
      margin-right: 20px;
      padding-top: 5px;
    }
  }

  .inquiryForm--result {
    p {
      font-size: 14px;
      color: #47536e;
      text-align: center;
      font-family: "Hiragino Kaku Gothic Pro W3";
      margin-bottom: 0px;
    }
  }
}

.message-area {
  border: #b3b3b3 1px solid;
  border-radius: 4px;
  padding: 36px;
  max-width: 700px;
}

.goToTopButton {
  margin-top: 36px;
  text-align: center;

  .buttonItem {
    border: none;
    border-radius: 4px;
    background-color: #9d8289;
    padding: 13px 61px;

    &:hover {
      opacity: 0.7;
    }
  }

  .buttonItem__text {
    margin: 0;
    color: #ffffff;
    font-size: 14px;
    font-family: "Hiragino Kaku Gothic Pro W3";
  }
}

@media screen and (max-width: 800px) {
  /* title */

  .contents__area--terms .title {
    padding: 32px 0px 24px 0px;
  }

  .formFrame {
    padding: 36px 0;

    .inquiryForm--result {
      margin-top: 36px;

      p {
        text-align: left;
      }
    }
  }

  /* button */

  .goToTopButton {
    .buttonItem {
      padding: 17px 151px;
    }

    .buttonItem__text {
      font-size: 16px;
    }
  }
}
</style>
